export function formatNumberToLocale(numberToFormat: number, locale?: 'en-IN') {
  return new Intl.NumberFormat(locale, { minimumFractionDigits: 2 }).format(numberToFormat);
}
